import React from 'react';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

export const WaitlistTopNav: React.FC = () => (
  <nav className="bg-white px-2 sm:px-4">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="flex justify-between items-center h-16">
        <div className="flex items-center min-w-0">
          <Link to="/" className="flex items-center gap-2 hover:opacity-80 transition-opacity">
            <img
              src={process.env.PUBLIC_URL + '/logo.png'}
              alt="SimpleTracker Logo"
              className="w-9 h-9 rounded-md shadow-sm"
            />
            <h1 className="text-xl font-bold text-gray-900">SimpleTracker</h1>
          </Link>
        </div>
        <div className="hidden md:flex items-center space-x-8">
          <HashLink
            smooth
            to="/#features"
            className="text-gray-600 hover:text-gray-900 px-3 py-2 text-sm font-medium transition-colors"
          >
            Features
          </HashLink>
          <HashLink
            smooth
            to="/#pricing"
            className="text-gray-600 hover:text-gray-900 px-3 py-2 text-sm font-medium transition-colors"
          >
            Pricing
          </HashLink>
          <Link
            to="/contact"
            className="text-gray-600 hover:text-gray-900 px-3 py-2 text-sm font-medium transition-colors"
          >
            Contact
          </Link>
        </div>
        <div className="flex items-center space-x-4">
          <button
            onClick={() => document.getElementById('waitlist-form')?.scrollIntoView({ behavior: 'smooth' })}
            className="bg-brand-500 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-brand-600 transition-colors"
          >
            Join Waitlist
          </button>
        </div>
      </div>
    </div>
  </nav>
);
